// extracted by mini-css-extract-plugin
export default {"content":"Future_content__Tu-TZ","live-switcher":"Future_live-switcher__7LjV8","trigger":"Future_trigger__9q709","note":"Future_note__DkFdb","actions":"Future_actions__257Pb"};